import React, { useEffect, useState } from "react";

import { trackPromise } from "react-promise-tracker";

import { Modal, Badge, Rate, Button, message } from "antd";

import { validarVisualizar } from "../../services/utils";

import TableHeader from "../Table/Header";
import TablePagination from "../Table/Pagination";

import favoritoSvg from "../../assets/icons/iconFavoritado.svg";
import pastaSvg from "../../assets/icons/infoPasta.svg";
import infoArquivoSvg from "../../assets/icons/infoArquivo.svg";
import "./styles.scss";

import ModalEditarPasta from "../../components/ModalEditarPasta";
import ModalEditarArquivo from "../../components/ModalEditarArquivo";
import ModalVisualizar from "../../components/ModalVisualizar";
import ModalListagemPastasArquivos from "../../components/ModalListagemPastasArquivos";

import services from "../../services";

import {
  listarPastarArquivosPorNotificacao,
  listarPastarArquivosSolicitacaoPorNotificacao,
  adicionarPastarArquivosNotificacaoSolicitacao,
  finalizarPastarArquivosNotificacaoSolicitacao,
  obterPastasArquivosFilhos

} from "../../services/http/pastaService";

const ModalListagemPastasArquivosNotificacao = ({
  data,
  mudarPagina,
  idNotificacao,
  closeModal,
  openModal,
  onLoadData,
  listarPastaArquivo, 
  favoritar,
  modalVisualizar,
  closeModalVisualizar,
  arquivoVisualizar,
  handleGerarLinkUnico,
  handleRemoverFavorito,
  removerItem,
  showInfo,
  showModalVisualizar

}) => { 
  const { IdUser, IsAdmin } = services.storage.getUser();
  const [pastasArquivos, setPastasArquivos] = useState([]);
  const [pastasArquivosSolicitacoes, setPastasArquivosSolicitacoes] = useState([]);
  const [dataVencimentoInicial, setDataVencimentoInicial] = useState("");
  const [dataVencimentoFinal, setDataVencimentoFinal] = useState("");
  const [horaInicial, setHoraInicial] = useState("");
  const [horaFinal, setHoraFinal] = useState("");
  const [selectAll, setSelectAll] = useState(false);
  const [comentario, setComentario] = useState("");
  const [modalEditarPasta, setModalEditarPasta] = useState(false);
  const [modalEditarArquivo, setModalEditarArquivo] = useState(false);
  const [tipoEditar, setTipoEditar] = useState("");
  const [idEditar, setIdEditar] = useState("");
  const [finalizado, setFinalizado] = useState(false);
  const [comentarioFinal, setComentarioFinal] = useState("");
  const [modalAbrirPasta, setModalAbrirPasta] = useState(false);
  const [pastasArquivosFilhos, setPastaArquivosFilhos] = useState([]);
  const [modalPastas, setModalPastas] = useState(false);
  const showModalPastas = () => {
    // if (naoConfiguravel) {
    //   message.error(`Não é permitido alteração`);
    //   return;
    // }
    setModalPastas(true);
  };
  const closeModalPastas = () => {
    setModalPastas(false);
  };

  const buscarListaPastasArquivosSolicitacoes = () => {
    if (idNotificacao.length == 0) return;

      trackPromise(
        listarPastarArquivosSolicitacaoPorNotificacao(idNotificacao)
          .then((res) => {
            if (!res.fail && res.data) {
              let solicitacoes = res.data.filter(item => item.descricao != null && item.descricao.length > 0);
              setPastasArquivosSolicitacoes(solicitacoes);
              setFinalizado(res.data.filter(item => item.final == 1).length > 0);
                
                if (res.data.filter(item => item.final == 1).length > 0) {
                  setComentarioFinal(res.data.filter(item => item.final == 1)[0].descricao);
                }
              
              
            }
          })
          .catch((error) => {
            console.error(error);
          })
      );
    };

  const buscarListaPastasArquivos = () => {
    if (idNotificacao.length == 0) return;

      trackPromise(
        listarPastarArquivosPorNotificacao(idNotificacao, IdUser)
          .then((res) => {
            if (!res.fail && res.data) {
              setPastasArquivos(res.data);
              buscarListaPastasArquivosSolicitacoes();
            }
          })
          .catch((error) => {
            console.error(error);
          })
      );
    };

  const enviarPastasArquivosSolicitacao = () => {
      if (idNotificacao.length == 0) return;

      let selectedFiles = getSelectedItems(false);
      if (selectedFiles.length == 0) {
        message.warning("Selecione ao menos um item para a solicitação");
        return;
      }

      let solicitacao = { solicitacao: { NotificacaoVencimentoIds: selectedFiles, Descricao: comentario } };
      //console.log(solicitacao.solicitacao);
      
      trackPromise(
        adicionarPastarArquivosNotificacaoSolicitacao(idNotificacao, solicitacao.solicitacao)
          .then((res) => {
            if (!res.fail && res.data) {
              buscarListaPastasArquivos();
              buscarListaPastasArquivosSolicitacoes();

              message.success("Solicitação enviada com sucesso");

              closeModal();
            }
          })
          .catch((error) => {
            console.error(error);
          })
      );
    };

  const formatarData = (value) => {
    if (value) {
      const data = new Date(value);
      return data.toLocaleDateString("pt-BR", { timeZone: "UTC" });
    }
  };

  const finalizarPastasArquivosSolicitacao = () => {
    if (idNotificacao.length == 0) return;

    let dataFinal = null; 
    if (dataVencimentoInicial.length > 0 && horaFinal.length > 0) 
      dataFinal = dataVencimentoInicial + ' ' + horaFinal;

    let selectedFiles = getSelectedItems(true);
    if (selectedFiles.length == 0) {
      message.warning("Selecione ao menos um item para a solicitação");
      return;
    }
    
    let solicitacao = { solicitacao: { NotificacaoVencimentoIds: selectedFiles, DataEnvioUtc: dataFinal, Descricao: comentario } };
    //console.log(solicitacao.solicitacao);
    
    trackPromise(
      finalizarPastarArquivosNotificacaoSolicitacao(idNotificacao, solicitacao.solicitacao)
        .then((res) => {
          if (!res.fail && res.data) {
            buscarListaPastasArquivos();
            buscarListaPastasArquivosSolicitacoes();

            message.success("Registros atualizados com sucesso");

            closeModal();
          }
        })
        .catch((error) => {
          console.error(error);
        })
    );
  };

  const toggleItem = (index) => {
    const updatedItems = [...pastasArquivos];
    updatedItems[index].selected = !updatedItems[index].selected;
    setPastasArquivos(updatedItems);
    setSelectAll(updatedItems.every((item) => item.selected));
  };
  const toggleAll = () => {
    const newSelectAll = !selectAll;
    const updatedItems = pastasArquivos.map((item) => ({
      ...item,
      selected: newSelectAll,
    }));
    setPastasArquivos(updatedItems);
    setSelectAll(newSelectAll);
  };
  const getSelectedItems = (getItemId) => {
      if (getItemId)
        return pastasArquivos.filter(item => item.selected).map(i => i.id);
      else 
        return pastasArquivos.filter(item => item.selected).map(i => i.notificacaoVencimentoId);

  };

  const tabelaColunas = [
    finalizado == true ? <Badge status="default" /> : <input type="checkbox" checked={selectAll} onChange={toggleAll} />,
    "Nome",
    "Data de validade",
    "Solicitações"
  ];

  const showEditarPasta = () => {
    setModalEditarPasta(true);
  };
  const closeEditarPasta = () => {
    buscarListaPastasArquivos();
    setModalEditarPasta(false);
  };
  const showEditarArquivo = () => {
    setModalEditarArquivo(true);
  };
  const closeEditarArquivo = () => {
    buscarListaPastasArquivos();
    setModalEditarArquivo(false);
  };
  const showEditar = (id, tipo) => {
      var t = tipo;
      setIdEditar(id);
      setTipoEditar(tipo);

      if (tipo == 0) {
        t = "pasta";
      }

      if (tipo == 1) {
        t = "arquivo";
      }

      if (t == "pasta") {
        showEditarPasta();
      } else {
        showEditarArquivo();
      }
  };
  const showModalAbrirPasta = () => {
    setModalAbrirPasta(true);
  };
  const closeModalPasta = () => {
    setModalAbrirPasta(false);
  };

  const buscarPastasArquivosFilhos = (idPasta) => {
    trackPromise(
      obterPastasArquivosFilhos(idPasta, 10, 1)
        .then((res) => {
          if (!res.fail && res.data) {
            setPastaArquivosFilhos(res.data);
            showModalAbrirPasta();
          }
        })
        .catch((error) => {
          console.error(error);
        })
    );
  };

  useEffect(() => {
      buscarListaPastasArquivos();
    }, []);

  return (
    <>
      <div className="teste">
        <Modal
          onCancel={closeModal}
          visible={openModal}
          className="modal-upload modal-expirados"
          destroyOnClose={true}
          okButtonProps={{ disabled: true }}
          footer={[]}
        >
          {!finalizado ? (
            <>
              <p>
              {IsAdmin.toLocaleLowerCase() == "true" ? (
                <span>
                Os arquivos e/ou pastas abaixo estão com data de vencimento
                próxima ou já venceram.
                </span>
              ) : (
                <span>
                Os arquivos e/ou pastas abaixo estão com data de vencimento
                próxima ou já venceram. Você pode solicitar a prorrogação e 
                ter eles disponíveis por mais tempo.
                </span>
              )}
              </p>
              <p>
              {IsAdmin.toLocaleLowerCase() == "true" ? (
                <span>
                Deseja prorrogar o prazo de validade ? 
                Clique sobre o arquivo/pasta e altere individualmente. 
                Ou selecione os desejados e defina uma data e hora para todas.
                </span>
              ) : (
                <span>
                Selecione os arquivos que deseja e clique em <b>Enviar!</b>
                </span>
              )}
              </p>
            </>
          ) : (
            <p>
              <span>
              Os seguintes arquivos / pastas foram atualizados.
              </span>
            </p>
          )}

          <table className="table table-borderless col-lg-12">
            <TableHeader columns={tabelaColunas} />
            <tbody>
              {(!pastasArquivos ||
                pastasArquivos.length === 0) && (
                <tr>
                  <td colSpan="7"> Sem Registros </td>
                </tr>
              )}
              {pastasArquivos &&
                pastasArquivos?.map((item, index) => (
                  <tr key={index}>
                    <td>
                    {finalizado == true ? (
                        <Badge status="default" />
                      ) : (
                        <input type="checkbox" 
                          checked={item.selected}
                          onChange={() => toggleItem(index)}/>
                      )}
                    </td>
                    <td onClick={() => IsAdmin.toLocaleLowerCase() == "true" ? showEditar(item.id, item.tipo) : (item.tipo == 0 ? buscarPastasArquivosFilhos(item.id) : showModalVisualizar(item)) }>
                      <span className="coluna-nome">
                        <img src={item.tipo == 0 ? pastaSvg : infoArquivoSvg} />
                        <span>{item.nome}</span>
                      </span>
                    </td>
                    <td onClick={() => IsAdmin.toLocaleLowerCase() == "true" ? showEditar(item.id, item.tipo) : (item.tipo == 0 ? buscarPastasArquivosFilhos(item.id) : showModalVisualizar(item))}> 
                      {formatarData(item.dataVencimentoFinal)} 
                    </td>
                    <td onClick={() => IsAdmin.toLocaleLowerCase() == "true" ? showEditar(item.id, item.tipo) : (item.tipo == 0 ? buscarPastasArquivosFilhos(item.id) : showModalVisualizar(item))} > 
                      <span>{item.countSolicitacoes}</span>
                    </td>
                  </tr>
                ))}
            </tbody>
          </table>
          {IsAdmin.toLocaleLowerCase() == "true" && 
            pastasArquivosSolicitacoes.length > 0 && (
            <div>
              <p class="title">Comentarios:</p>
              <div class="comments">
                <ul>
                {pastasArquivosSolicitacoes?.map((item, index) => (
                  <li>
                    <p>{item.descricao}</p>
                    <span>Usuário: {item.usuario}, {formatarData(item.dataEnvioUtc)} </span>
                  </li>                
                ))}
                </ul>
              </div>
            </div>
          )}

          {finalizado == false ? (
          <div>
            <p class="title">
              Escreva um comentário (opcional):
            </p>
            <textarea
            onChange={(e) => setComentario(e.target.value)}
            value={comentario}
            ></textarea>
          </div>
          ) : (
            <div>
              <p class="title">
                Comentário do administrador:
              </p>
              <textarea
              disabled="disabled"
              value={comentarioFinal}
              >{comentarioFinal}</textarea>
            </div>
          )}
          <div>
          {IsAdmin.toLocaleLowerCase() == "true" && finalizado == false && (
            <div className="group-data-hora-pasta label-input">
              <div class="left">
                <label className="label-data-inicio">Nova data</label>
                <input
                  disabled={IsAdmin.toLocaleLowerCase() != "true"}
                  className="input-data-arquivo"
                  type="date"
                  onChange={(e) => setDataVencimentoInicial(e.target.value)}
                  value={dataVencimentoInicial}
                />
              </div>
              <div class="right">
                  <label className="label-data-inicio">Nova hora</label>
                  <input
                    disabled={IsAdmin.toLocaleLowerCase() != "true"}
                    className="input-data-arquivo"
                    type="time"
                    onChange={(e) => setHoraFinal(e.target.value)}
                    value={horaFinal}
                  />
              </div>
            </div>
          )}
            <div className="editar-pasta-buttons-finalizar-editar">
              {!finalizado && (
              <div className="editar-pasta-buttons-publicar ">
              {IsAdmin.toLocaleLowerCase() == "true" ? (
                <button
                  className="editar-pasta-button-publicar-todos-novo"  
                  onClick={finalizarPastasArquivosSolicitacao}
                >
                  APLICAR E FINALIZAR
                </button>
              ): (
                <button
                  className="editar-pasta-button-publicar-todos-novo"
                  onClick={enviarPastasArquivosSolicitacao}
                >
                  ENVIAR
                </button>
              )}
              </div>
              )}
              <div className="editar-pasta-buttons-publicar ">
                <button
                  onClick={closeModal}
                  className="editar-pasta-button-publicar-mim-novo"
                >
                  FECHAR
                </button>
              </div>
              
            </div>
          </div>
          <hr className="editar-pasta-linha" />
          <br />
        </Modal>

        {modalEditarPasta && (
          <ModalEditarPasta
            id={idEditar}
            tipo={tipoEditar}
            closeModal={closeEditarPasta}
            openModal={modalEditarPasta}
            buscar={listarPastaArquivo}
            onLoadData={onLoadData}
          />
        )}

        {modalEditarArquivo && (
          <ModalEditarArquivo
            id={idEditar}
            tipo={tipoEditar}
            closeModal={closeEditarArquivo}
            openModal={modalEditarArquivo}
            buscar={listarPastaArquivo}
          />
        )}

        {modalVisualizar && (
          <ModalVisualizar
            openModal={modalVisualizar}
            closeModal={closeModalVisualizar}
            arquivo={arquivoVisualizar}
            handleGerarLinkUnico={handleGerarLinkUnico}
            IsAdmin={IsAdmin}
            handleRemoverFavorito={handleRemoverFavorito}
            removerItem={removerItem}
            showInfo={showInfo}
            favoritar={favoritar}
          />
        )}

        {modalAbrirPasta && (
          <ModalListagemPastasArquivos
            openModal={modalAbrirPasta}
            closeModal={closeModalPasta}
            pastasArquivosFilhos={pastasArquivosFilhos}
            showCloseBtn={true}
          />
        )}

      </div>
    </>
  );
};



export default ModalListagemPastasArquivosNotificacao;
